import React, { useContext, useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { DatePicker } from 'ui-components/components/date-picker';

import { MarkAsShippedContext } from '../../../context';

import Global from '../../../../../store/global-selectors';

import style from '../../style.module.less';

import { getShipDate } from '../../../helper';

const messages = defineMessages({
  datePickerPlaceholderText: {
    description: 'Mark as shipped date placeholder text',
    defaultMessage: 'Ship Date',
    id: 'u7dHrJ',
  },
});

const BulkUpdateShipDate = () => {
  const intl = useIntl();
  const { bulkUpdateFulfillmentPlans } = useContext(MarkAsShippedContext);

  const dateFormat = useSelector(Global.selectUserUserDateFormat);

  const onChange = useCallback(
    (date) => {
      if (moment(date, dateFormat).isValid()) {
        bulkUpdateFulfillmentPlans('shipDate', getShipDate(date, dateFormat));
      }
    },
    [bulkUpdateFulfillmentPlans, dateFormat],
  );

  return (
    <div className={style['bulk-update-item']}>
      <DatePicker
        allowPastDates
        dateFormat={dateFormat}
        onChange={onChange}
        placeholder={intl.formatMessage(messages.datePickerPlaceholderText)}
        value={null}
      />
    </div>
  );
};

export default BulkUpdateShipDate;
